<template lang="pug">
  transition(
    appear
    v-on:leave="leave"
  )
    .Preloader
      SvgInline(src="relief")
      .Preloader_content
        h1.Preloader_title(v-html="$t('preloader.title')")
        p.Preloader_subtitle {{ $t('preloader.subtitle', { count: Math.round( count ) }) }}
      LogoDiamonds(ref="logo", :isLoader="true")
</template>

<script>

import SvgInline from '@/components/SvgInline'
import LogoDiamonds from '@/components/LogoDiamonds'
import DrawSVGPlugin from '@/libs/DrawSVGPlugin.min.js'
import { TweenMax, Power3 } from 'gsap'

export default {
  components: { LogoDiamonds, SvgInline },
  data () {
    return {
      count: 10000
    }
  },
  mounted () {
    TweenMax.fromTo(this.$el.querySelectorAll('svg'), 1, {opacity: 0}, { opacity: 0.05, ease: Power2.easeInOut})
    TweenMax.fromTo(this.$el.querySelectorAll('path'), 4, {drawSVG: '0%', opacity: 0}, { opacity: 1, drawSVG: '100%', ease: Power2.easeInOut})
    TweenMax.to(this, 2, { count: 27421, ease: Power3.easeOut })
  },
  methods: {
    /**
     * Animation de disparition du composant
     */
    leave (el, done) {
      this.$refs.logo.leave(done)
    }
  },
  beforeDestroy () {
    TweenMax.killTweensOf(this.$el.querySelectorAll('path'))
  }
}

</script>

<style lang="stylus" scope>
.Preloader
  z-index: 0
  position: fixed
  top 0
  left 0
  bottom 0
  right 0
  background-color $beige

  svg

    min-width 100vw
    min-height 100vh
    position absolute
    z-index -1
    opacity 0.05
    top 0px
    left 0px
    right 0px
    bottom 0px

  //---
  // Animation d'apparition
  //---
  &.v-enter
    .Preloader_title
      opacity: 0
    .Preloader_subtitle
      opacity: 0

  &.v-enter-active
    transition all 1.4s $ease // temps total de l'animation

    .Preloader_title
      transition all 1.2s $ease
    .Preloader_subtitle
      transition all 1.2s $ease .2s
  //--- fin anim apparition

  &_content
    box-sizing border-box
    display: flex
    flex-direction: column
    height 100%
    align-items center
    justify-content: center

  &_title
    text-transform uppercase
    color $grey-2
    text-align center
    font-size: 7.5vw
    line-height @font-size

    @media $mq_m
      color $beige-l

    @media $mq_l
      margin-top 3.125vw

  &_subtitle
    text-transform uppercase
    text-align center
    font-weight: 400
    font-size: 10px
    line-height 1em
    margin-top 3.125vw
    margin-top 220px

    @media $mq_m
      font-size 14px
      margin-top 110px

    @media $mq_l
      font-size: 1vw
      margin-top 3.125vw

</style>
